(function () {
  function flash(q) {
    q.classList.remove('carni-qty-updating');
    q.classList.add('carni-qty-confirm');
    setTimeout(function () { q.classList.remove('carni-qty-confirm'); }, 500);
  }
  // Track what the shopper asked for, so a silently-clamped response (Shopify caps a
  // DENY-policy item at available stock, without any error) can be explained instead
  // of looking like the click "didn't work".
  var expect = null; // { inputId, value }
  function arm(target) {
    var q = target.closest && target.closest('quantity-input.quantity');
    if (!q) return;
    if (q.classList.contains('cart-quantity')) {
      var input = q.querySelector('.quantity__input');
      if (input) {
        var isPlus = !!(target.closest && target.closest('.quantity__button[name="plus"]'));
        var step = parseInt(input.step || '1', 10) || 1;
        var want = parseInt(input.value, 10) || 0;
        if (target.tagName === 'INPUT') want = parseInt(target.value, 10) || want;
        else want = isPlus ? want + step : want - step;
        expect = { inputId: input.id, value: want };
      }
      // cart pills wait on the network: pulse until the new cart state lands
      q.classList.add('carni-qty-updating');
      // safety: never pulse forever if the update errors out
      setTimeout(function () { q.classList.remove('carni-qty-updating'); }, 6000);
    } else {
      // PDP pills change instantly: straight to the bold-border confirm
      flash(q);
    }
  }
  function noteClamp() {
    if (!expect || !expect.inputId) { expect = null; return; }
    var input = document.getElementById(expect.inputId);
    if (input) {
      var actual = parseInt(input.value, 10);
      if (isFinite(actual) && expect.value > actual) {
        var q = input.closest('quantity-input');
        var host = q ? q.parentElement : null;
        if (host && !host.querySelector('.carni-qty-note')) {
          var note = document.createElement('span');
          note.className = 'carni-qty-note';
          note.setAttribute('role', 'status');
          note.textContent = 'Only ' + actual + ' available';
          q.insertAdjacentElement('afterend', note);
          setTimeout(function () { note.remove(); }, 3000);
        }
      }
    }
    expect = null;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('quantity-input.quantity .quantity__button')) arm(e.target);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('quantity-input.quantity')) arm(e.target);
  }, true);

  function confirmAll() {
    document.querySelectorAll('quantity-input.cart-quantity').forEach(function (q) {
      q.classList.remove('carni-qty-updating');
      q.classList.add('carni-qty-confirm');
      setTimeout(function () { q.classList.remove('carni-qty-confirm'); }, 650);
    });
  }
  function hook() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(function () { confirmAll(); noteClamp(); }, 80);
      });
      return true;
    }
    return false;
  }
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);

  // The cart "janitor" (merging duplicate same-variant lines left by the legacy
  // Bundler app) was REMOVED 2026-08-21: its zero-then-re-add merge could lose
  // cart items on a mid-merge failure, and it fired after every cart update. The
  // custom card stepper handles multi-line variants correctly on its own; any
  // remaining old duplicate lines resolve as customers edit or reorder.
})();
